import { lazy } from 'react'

// Home
export const HomePage = lazy(() =>
  import('@shared/components/pages/home-page').then((module) => ({ default: module.HomePage }))
)

// Customers
export const CustomersListPage = lazy(() => import('@features/customers/pages/CustomersListPage'))
export const CustomerDetailsPage = lazy(() =>
  import('@features/customers/pages/CustomerDetailsPage')
)

// Merchants
export const MerchantsApplicationsPage = lazy(() =>
  import('@features/merchants/pages/MerchantsApplicationsPage')
)
export const MerchantDetailsPage = lazy(() =>
  import('@features/merchants/pages/MerchantDetailsPage')
)
export const CreateMerchantPage = lazy(() =>
  import('@features/merchants/pages/CreateMerchantPage')
)

// Cover
export const CoverListPage = lazy(() => import('@features/cover/pages/CoverListPage'))

// Settings
export const SettingsRouter = lazy(() => import('@shared/components/pages/SettingsRouter'))
export const PersonalDetailsPage = lazy(() => import('@shared/components/pages/personal-details-page'))
export const TeamSecurityPage = lazy(() => import('@features/team-security/pages/TeamSecurityPage'))
export const BalanceSettingsPage = lazy(() =>
  import('@features/financial-hub/pages/BalanceSettingsPage').then((m) => ({
    default: m.BalanceSettingsPage,
  }))
)

// Reporting
export const ReportsPage = lazy(() => import('@features/reporting/pages/ReportsPage'))
export const PipelinesPage = lazy(() => import('@features/reporting/pages/PipelinesPage'))

// Integrations
export const IntegrationsPage = lazy(() => import('@features/integrations/pages/IntegrationsPage'))

// Account activation
export const AccountActivationPage = lazy(() =>
  import('@features/account-activation/pages/AccountActivationPage')
)

// 404
export const NotFoundPage = lazy(() => import('@shared/components/pages/NotFoundPage'))

// Dev tools
export const ComponentDemoPage = lazy(() => import('@features/dev-tools/pages/ComponentDemoPage'))
export const ComponentLibraryPage = lazy(() => import('@features/dev-tools/pages/ComponentLibraryPage'))
export const TransactionComponentLibraryPage = lazy(() =>
  import('@features/dev-tools/pages/TransactionComponentLibraryPage').then((m) => ({
    default: m.TransactionComponentLibraryPage,
  }))
)
export const TestPage = lazy(() => import('@features/dev-tools/pages/TestPage'))
export const OpportunitiesComponentsPage = lazy(() =>
  import('@features/dev-tools/pages/OpportunitiesComponentsPage')
)
export const PaymentsCostComponentsPage = lazy(() =>
  import('@features/dev-tools/pages/PaymentsCostComponentsPage')
)
export const SheetsComponentsPage = lazy(() =>
  import('@features/dev-tools/pages/SheetsComponentsPage').then((m) => ({
    default: m.SheetsComponentsPage,
  }))
)
export const DialogsComponentsPage = lazy(() =>
  import('@features/dev-tools/pages/DialogsComponentsPage').then((m) => ({
    default: m.DialogsComponentsPage,
  }))
)
export const RulesComponentsPage = lazy(() =>
  import('@features/dev-tools/pages/RulesComponentsPage')
)
export const RiskScoresPage = lazy(() =>
  import('@features/dev-tools/pages/RiskScoresPage')
)
export const BadgesPage = lazy(() =>
  import('@features/dev-tools/pages/BadgesPage')
)
export const IconsPage = lazy(() =>
  import('@features/dev-tools/pages/IconsPage')
)
export const SonarRuleTemplatePage = lazy(() =>
  import('@/features/dev-tools/pages/SonarRuleTemplatePage').then((m) => ({
    default: m.SonarRuleTemplatePage,
  }))
)
